import React from 'react';
import Column from '@amzn/meridian/column';
import Heading from '@amzn/meridian/heading';
import Text from '@amzn/meridian/text';

const NotFound: React.FC = () => (
    <Column spacing="300" spacingInset="500">
        <Heading level={2}>Page not found</Heading>
        <Text>The page you're looking for doesn't exist.</Text>
    </Column>
);

export default NotFound;
